import { createSlice } from "@reduxjs/toolkit";
import { handleSidebarLayout } from "../../../helpers/sideBarToggle";
import {
  getBankList,
  getDraftLetters,
  getInboxLetters,
  getSentLetters,
  readLetter,
} from "../actions/app";
import { formatErrorMessage } from "../../../helpers/helpers";

const initialState = {
  userLoading: false,
  userErrorMsg: null,
  unSeenSuccessMsg: null,
  userSuccessMsg: null,
  isSidebarOpen: true,
  isActive: "dashboard",
  isRefreshed: "",
  // activeModule : 'Dashboard',
  isSubActive: "",
  isToggle: false,
  currencies: [],
  banks: [],
  searchResult: {
    searchResultData: {},
    newData: false,
    searchResultDetails: "",
    certificateSearchValue: "",
  },
  certificateManagement: {
    certificatesData: [],
    // newData: false,
    certificateDetails: "",
    // showCertificateForm: false,
    showStatusChangeConfirmation: false,
    showCommentForm: false,
    // additionalDocs: [],
    showCommentFormNotap: false,
    showCommentFormTrans: false,
    comments: [],
    newComment: false,
    certificateStatus: "",
    certificateStatusConfirmationBtnText: "",
    documentType: "Certificate",
    showDocumentModal: false,
    document_file_path: "",
  },
  userManagement: {
    usersData: [],
    showChangePasswordForm: false,
  },
  digitalLetterManagement: {
    inboxLetters: [],
    draftLetters: [],
    sentLetters: [],
    inboxLetterDetails: "",
    generalLetterDetails: "",
    draftLetterDetails: "",
    sentLetterDetails: "",
    activeEmailTab: "inbox",
    showDeleteConfirmationForm: false,
    showAttachmentModal: false,
    newLetter: false,
    showSendLetterConfirmationModal: false,
    showLetterEvaluationForm: false,
    // letterStatus: ''
  },
  evaluationManagement: {
    evaluationsData: [],
    evaluationDetails: "",
    newData: false,
    showCommentRichTextForm: false,
    showEvaluationDetails: false,
    showSendEvalForm: false,
    hasBeenSent: false,
    hasAddedEval: false,
    evalStatus: "draft",
    evalId: null,
    showDocumentCarousel: false,
  },
};

export const appSlice = createSlice({
  name: "appApp",
  initialState,
  reducers: {
    logoutAppUser: (state, action) => {
      return initialState;
    },
    onSidebarChange: (state) => {
      handleSidebarLayout();
    },
    onLoadMinimize: (state) => {
      state.isSidebarOpen = false;
      let x = document.getElementById("html_tag");
      //wf-active nav_open
      // !state.isSidebarOpen ?   x.classList.add("sidebar_minimize") : x.classList.remove("sidebar_minimize")
      x.classList.remove("nav_open");
    },
    onToggleClick: (state) => {
      state.isToggle = !state.isToggle;
      let x = document.getElementById("html_tag");
      !state.isToggle
        ? x.classList.add("wf-active")
        : x.classList.remove("wf-active");
      !state.isToggle
        ? x.classList.add("topbar_open")
        : x.classList.remove("topbar_open");
    },

    // setIsRefreshed: (state) => {
    //   // Changing this to a boolean toggle ensures useEffect always detects a change
    //   state.isRefreshed = !state.isRefreshed;
    // },

    setActiveSidebar: (state, action) => {
      state.isActive = action.payload.mainPath;
      // state.activeModule = action.payload.moduleName
      // state.subPath = action.payload.subPath
    },
    clearOnReload: (state, action) => {
      state.certificateManagement = {
        ...initialState.certificateManagement,
        certificateDetails: state.certificateManagement.certificateDetails,
      };
      state.digitalLetterManagement = {
        ...initialState.digitalLetterManagement,
        generalLetterDetails:
          state.digitalLetterManagement.generalLetterDetails,
        inboxLetterDetails: state.digitalLetterManagement.inboxLetterDetails,
        sentLetterDetails: state.digitalLetterManagement.sentLetterDetails,
        draftLetterDetails: state.digitalLetterManagement.draftLetterDetails,
      };
    },
    clearResetBot: (state) => {
      state.certificateManagement.newComment = false;
      state.searchResult.newData = false;
      state.evaluationManagement.newData = false;
    },
    clearAll: (state, action) => {
      state.userLoading = false;
      state.userErrorMsg = null;
      state.userSuccessMsg = null;
      state.unSeenSuccessMsg = null;
    },
    setLoadingUser: (state, action) => {
      state.userLoading = action?.payload?.loading;
    },

    setErrorMessageUser: (state, action) => {
      let msg = action.payload.message;
      state.userLoading = false;
      state.userErrorMsg = msg;
    },
    setSuccessMessageUser: (state, action) => {
      let msg = action.payload.message;
      state.userLoading = false;
      state.userSuccessMsg = msg;
    },
    showCommentFormFunc: (state, action) => {
      state.certificateManagement.showCommentForm = action.payload.modal;
      state.certificateManagement.showCommentFormNotap = action.payload.modal;
      state.certificateManagement.showCommentFormTrans = action.payload.modal;
    },
    showStatusChangeConfirmationFunc: (state, action) => {
      state.certificateManagement.showStatusChangeConfirmation =
        action.payload.modal;
    },
    onGetCurrencies: (state, action) => {
      state.currencies = action.payload;
    },
    onGetBanks: (state, action) => {
      state.banks = action.payload;
    },
    onGetHistory: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.certificateManagement.certificatesData = action.payload;
      state.certificateManagement.newData = true;
    },
    setCertificateDetailsGeneral: (state, action) => {
      state.certificateManagement.certificateDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    onGetComments: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.certificateManagement.comments = action.payload;
    },
    onAddCommentGeneral: (state, action) => {
      state.certificateManagement.newComment = true;
    },
    setConfirmationStatusModalText: (state, action) => {
      state.certificateManagement.certificateStatus =
        action.payload.status ?? state.certificateManagement.certificateStatus;
      state.certificateManagement.certificateStatusConfirmationBtnText =
        action.payload.btnText ??
        state.certificateManagement.certificateStatusConfirmationBtnText;
      state.certificateManagement.documentType =
        action.payload.documentType ?? state.certificateManagement.documentType;
    },
    onGetSearchResultGeneral: (state, action) => {
      // state.transfereeUserSuccessMsg = ''
      state.searchResult.searchResultData = action.payload;
      state.searchResult.newData = true;
    },
    onSearch: (state, action) => {
      state.searchResult.certificateSearchValue = action.payload.searchValue;
    },
    clearResponseMsg: (state, action) => {
      state.userErrorMsg = null;
      state.userSuccessMsg = null;
      state.unSeenSuccessMsg = null;
    },
    onGetUsers: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.userManagement.usersData = action.payload;
    },
    onGetInboxLetters: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.digitalLetterManagement.inboxLetters = action.payload;
    },
    onGetDraftLetters: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.digitalLetterManagement.draftLetters = action.payload;
    },
    onGetSentLetters: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.digitalLetterManagement.sentLetters = action.payload;
    },
    onSendLetter: (state, action) => {
      state.userSuccessMsg = action.payload.message;
      state.digitalLetterManagement.showSendLetterConfirmationModal = false;
    },
    onDeleteLetter: (state, action) => {
      state.userSuccessMsg = "Letter Deleted Successfully";
      state.digitalLetterManagement.showDeleteConfirmationForm = false;
      state.digitalLetterManagement.newLetter = true;
    },
    showDeleteConfirmationFunc: (state, action) => {
      state.digitalLetterManagement.showDeleteConfirmationForm =
        action.payload.modal;
    },
    // showStatusChangeConfirmationFunc: (state, action) => {
    //     state.certificateManagement.showStatusChangeConfirmation = action.payload.modal
    // },
    showAttachmentFunc: (state, action) => {
      state.digitalLetterManagement.showAttachmentModal = action.payload.modal;
    },
    setInboxLetterDetails: (state, action) => {
      state.digitalLetterManagement.inboxLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setGeneralLetterDetails: (state, action) => {
      state.digitalLetterManagement.generalLetterDetails =
        action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setDraftLetterDetails: (state, action) => {
      state.digitalLetterManagement.draftLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setSentLetterDetails: (state, action) => {
      state.digitalLetterManagement.sentLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    onGetSearchResult: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      // state.searchResult.searchResultData = action.payload
      // state.searchResult.newData = true
    },
    setActiveEmailTab: (state, action) => {
      state.digitalLetterManagement.activeEmailTab = action.payload.name;
    },
    showDocumentModalFunc: (state, action) => {
      state.certificateManagement.showDocumentModal = action.payload.modal;
      state.certificateManagement.document_file_path = action.payload.url;
    },
    setDocumentPath: (state, action) => {
      state.certificateManagement.document_file_path = action.payload.url;
    },
    showSendLetterConfirmationModalFunc: (state, action) => {
      state.digitalLetterManagement.showSendLetterConfirmationModal =
        action.payload.modal;
    },
    showLetterEvaluationFormFunc: (state, action) => {
      state.digitalLetterManagement.showLetterEvaluationForm =
        action.payload.modal;
    },
    onGetLetterEval: (state, action) => {
      state.userSuccessMsg = "";
      state.unSeenSuccessMsg = "";
      state.evaluationManagement.evaluationsData = action.payload;
      state.evaluationManagement.newData = true;
    },
    // onAddLetterEval: (state, action) => {
    //     state.userSuccessMsg = 'Evaluation Added Successfully'
    //     state.digitalLetterManagement.showLetterEvaluationForm = false
    // },
    setEvalDetails: (state, action) => {
      state.evaluationManagement.evaluationDetails = action.payload.details;
    },
    onSendLetterEval: (state, action) => {
      state.userSuccessMsg = action.payload.message;
      state.unSeenSuccessMsg = action.payload.unseen;
      state.digitalLetterManagement.showSendLetterConfirmationModal = false;
      state.digitalLetterManagement.generalLetterDetails = {
        ...state.digitalLetterManagement.generalLetterDetails,
        NOTAP_STAFF_USER: action.payload.email,
      };
    },
    showEvaluationDetailsFunc: (state, action) => {
      state.evaluationManagement.showEvaluationDetails = action.payload.modal;
    },
    setIsRefreshed: (state, action) => {
      state.isRefreshed = "done";
    },
    showChangePasswordFormFunc: (state, action) => {
      state.userManagement.showChangePasswordForm = action.payload.modal;
    },
    onChangePassword: (state, action) => {
      state.userSuccessMsg = action.payload.message;
      state.userManagement.showChangePasswordForm = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankList.fulfilled, (state, action) => {
        state.banks = action.payload.data;
      })
      .addCase(getSentLetters.fulfilled, (state, action) => {
        state.userLoading = false;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";

        state.digitalLetterManagement.sentLetters = action.payload.data;
      })
      .addCase(getSentLetters.rejected, (state, action) => {
        state.userLoading = false;

        if (action.payload)
          state.userErrorMsg = action.payload.error || action.payload.message;
        else state.userErrorMsg = formatErrorMessage(action.error);
      })
      .addCase(getSentLetters.pending, (state) => {
        state.userLoading = true;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";
      })
      .addCase(getInboxLetters.fulfilled, (state, action) => {
        state.userLoading = false;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";

        state.digitalLetterManagement.inboxLetters = action.payload.data;
      })
      .addCase(getInboxLetters.rejected, (state, action) => {
        state.userLoading = false;

        if (action.payload)
          state.userErrorMsg = action.payload.error || action.payload.message;
        else state.userErrorMsg = formatErrorMessage(action.error);
      })
      .addCase(getInboxLetters.pending, (state) => {
        state.userLoading = true;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";
      })
      .addCase(getDraftLetters.fulfilled, (state, action) => {
        state.userLoading = false;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";

        state.digitalLetterManagement.draftLetters = action.payload.data;
      })
      .addCase(getDraftLetters.rejected, (state, action) => {
        state.userLoading = false;

        if (action.payload)
          state.userErrorMsg = action.payload.error || action.payload.message;
        else state.userErrorMsg = formatErrorMessage(action.error);
      })
      .addCase(getDraftLetters.pending, (state) => {
        state.userLoading = true;

        state.userErrorMsg = "";
        state.userSuccessMsg = "";
        state.unSeenSuccessMsg = "";
      })
      .addCase(readLetter.fulfilled, (state) => {
        state.userLoading = false;
      })
      .addCase(readLetter.rejected, (state, action) => {
        state.userLoading = false;
      })
      .addCase(readLetter.pending, (state) => {
        state.userLoading = true;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  onSearch,
  onGetUsers,
  clearResponseMsg,
  onGetSearchResultGeneral,
  onSidebarChange,
  setActiveSidebar,
  onLoadMinimize,
  onToggleClick,
  onGetCurrencies,
  onGetBanks,
  onGetHistory,
  showCommentFormFunc,
  clearAll,
  clearResetBot,
  setCertificateDetailsGeneral,
  setErrorMessageUser,
  setLoadingUser,
  setSuccessMessageUser,
  showStatusChangeConfirmationFunc,
  logoutAppUser,
  onGetComments,
  // onGetAdditionalDocuments,
  onAddCommentGeneral,
  clearOnReload,
  setConfirmationStatusModalText,
  // showStatusChangeConfirmationFunc,
  onDeleteLetter,
  showDeleteConfirmationFunc,
  onGetInboxLetters,
  onGetDraftLetters,
  onGetSentLetters,
  setInboxLetterDetail,
  setActiveEmailTab,
  onSendLetter,
  setInboxLetterDetails,
  setGeneralLetterDetails,
  setDraftLetterDetails,
  setSentLetterDetails,
  showAttachmentFunc,
  showDocumentModalFunc,
  setDocumentPath,
  showSendLetterConfirmationModalFunc,
  showLetterEvaluationFormFunc,
  onGetLetterEval,
  // onAddLetterEval,
  onSendLetterEval,
  setEvalDetails,
  showEvaluationDetailsFunc,
  setIsRefreshed,
  showChangePasswordFormFunc,
  onChangePassword,
} = appSlice.actions;

export default appSlice.reducer;
